import { useMemo } from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { toAppointments } from '../mappers/appointment.js';
import GET_MY_APPOINTMENTS from '../operations/queries/get-my-appointments.js';

const useAppointments = ()=>{
    var ref1;
    const { data , loading , error  } = useQuery(GET_MY_APPOINTMENTS);
    return useMemo(()=>{
        var ref;
        return {
            data: toAppointments(data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.appointments),
            loading,
            error
        };
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.me) === null || ref1 === void 0 ? void 0 : ref1.appointments,
        error,
        loading
    ]);
};

export { useAppointments };
//# sourceMappingURL=useAppointments.js.map
